import { Package } from "@raskrask-dk/raskrask-utils";
import type PackageState from "..";
import {Action} from "../../../action/action";


const NEXT_STATE = "NEXT_STATE";
export class Next extends Action<typeof NEXT_STATE, undefined> {
  readonly type = NEXT_STATE;
  protected state: PackageState;

  constructor(state: PackageState, data?: undefined) {
    super(state, data);
    this.state = state;
  }

  public isValid = (): boolean => {
    if (this.state.packageTemplate && this.state.partner) return this.isDoable();
    return false;
  };

  public isDoable = (): boolean => {
    const {packageTemplate, partner} = this.state;
    if (packageTemplate !== undefined && partner !== undefined) {
      const canConstructPackage = Package.fromPackageTemplate(packageTemplate, partner) !== undefined;
      return canConstructPackage;
    }
    return false;
  };
}
